import { AsyncPipe } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit,
} from '@angular/core';
import { YouTubePlayerModule } from '@angular/youtube-player';
import { CookieConsentService } from '@core/services/cookie-consent.service';
import { YoutubeApiLoadingService } from '@features/youtube/service/youtube-api-loading.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faYoutube } from '@fortawesome/free-brands-svg-icons';
import { Observable } from 'rxjs';
import { IntersectionObserverDirective } from '../../../../shared/intersection-observer/intersection-observer.directive';
import { ConsentAcceptButtonComponent } from '../../../consent/components/consent-accept-button/consent-accept-button.component';

@Component({
    selector: 'app-youtube-player-lazy',
    templateUrl: './youtube-player-lazy.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        YouTubePlayerModule,
        IntersectionObserverDirective,
        FontAwesomeModule,
        ConsentAcceptButtonComponent,
        AsyncPipe,
    ],
})
export class YoutubePlayerLazyComponent implements OnInit {
    @Input() videoId: string;
    cookieConsent: Observable<boolean>;
    faYoutube = faYoutube;

    constructor(
        private youtubeApiLoadingService: YoutubeApiLoadingService,
        private cookieConsentService: CookieConsentService
    ) {}

    ngOnInit(): void {
        this.cookieConsent = this.cookieConsentService.consentChanged;
    }
    loadApi(visible: boolean) {
        if (visible) {
            this.youtubeApiLoadingService.loadApi();
        }
    }
}
